let daysArray = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

export default daysArray;
